function isLocal(url: string): boolean {
  return url.startsWith('http://localhost') || url.startsWith('http://127.0.0.1')
}

/** Build headers for Firebase Storage upload. Adds emulator auth bypass for localhost URLs. */
export function storageHeaders(url: string, contentType: string): Record<string, string> {
  const h: Record<string, string> = { 'Content-Type': contentType }
  if (isLocal(url)) h['Authorization'] = 'Bearer owner'
  return h
}

/**
 * Upload a blob to Firebase Storage.
 * Emulator URLs require POST; production signed URLs require PUT.
 */
export function storageUpload(url: string, body: Blob, contentType: string): Promise<Response> {
  return fetch(url, {
    method:  isLocal(url) ? 'POST' : 'PUT',
    headers: storageHeaders(url, contentType),
    body,
  })
}
